const MapViewType = {
	ALERTS: "alerts",
	FLEET_HISTORY: "fleet-history",
	NEARBY_VESSELS: "nearby-vessels"
};
export default MapViewType;
